import { Gamepad2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CategoryMenuItemProps {
	icon: React.ComponentType<{ className?: string }> | string | null
	label: string
	count?: number
	isActive: boolean
	onClick: () => void
}

export function CategoryMenuItem({ icon, label, count, isActive, onClick }: CategoryMenuItemProps) {
	const Icon = typeof icon == 'function' || typeof icon === 'object' ? icon : null

	return (
		<div className={cn('group overflow-hidden rounded-xl border p-0.5 transition-colors', isActive ? 'border-primary' : 'border-border')}>
			<button
				type='button'
				onClick={onClick}
				className={cn(
					'flex w-full items-center justify-between gap-2 overflow-hidden rounded-[10px] py-2 pl-1 pr-3.5 text-left transition-colors hover:bg-transparent',
					isActive ? 'bg-secondary bg-[linear-gradient(90deg,hsl(var(--primary)/0.12)_1.15%,hsl(var(--primary)/0)_82.95%)]' : 'bg-secondary',
				)}
			>
				<span className='flex items-center gap-2'>
					<span
						aria-hidden
						className={cn(
							'h-4 w-0.5 shrink-0 rounded-full transition-[background-color,box-shadow]',
							isActive
								? 'bg-primary shadow-[0_0_12px_6px_hsl(var(--primary)/0.6)]'
								: 'bg-border group-hover:bg-primary group-hover:shadow-[0_0_8px_2px_hsl(var(--primary)/0.35)]',
						)}
					/>

					{Icon ? (
						<Icon className={cn('h-6 w-6 shrink-0 transition-colors', isActive ? 'text-primary' : 'text-icon-muted group-hover:text-primary')} />
					) : icon ? (
						<span
							aria-hidden
							className={cn(
								'h-6 w-6 shrink-0 bg-current transition-colors [-webkit-mask-position:center] [-webkit-mask-repeat:no-repeat] [-webkit-mask-size:contain] [mask-position:center] [mask-repeat:no-repeat] [mask-size:contain]',
								isActive ? 'text-primary' : 'text-icon-muted group-hover:text-primary',
							)}
							style={{
								maskImage: `url(${icon})`,
								WebkitMaskImage: `url(${icon})`,
							}}
						/>
					) : (
						<Gamepad2 className={cn('h-6 w-6 shrink-0 transition-colors', isActive ? 'text-primary' : 'text-icon-muted group-hover:text-primary')} />
					)}

					<span className={cn('text-sm tracking-[-0.21px] transition-colors', isActive ? 'font-medium text-foreground' : 'font-normal text-muted-foreground')}>
						{label}
					</span>
				</span>
				{typeof count === 'number' ? <span className='text-sm font-normal tracking-[-0.21px] text-muted-foreground'>{count}</span> : null}
			</button>
		</div>
	)
}
